import styled from '@emotion/styled'
import {PALETTE} from '../styles/paletteV3'

const DialogTitle = styled('h2')({
  color: PALETTE.SLATE_700,
  fontSize: 20,
  fontWeight: 600,
  lineHeight: 1.5,
  margin: 0,
  padding: '20px 24px 0',
  display: 'flex'
})

export default DialogTitle
